import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { MutationOption, queryClient } from "libs/react-query";
import * as KeyFactory from "./exchange-query-key-factory";
import * as VariantKeyFactory from "../../mitigation/variant/variant-query-key-factory";

interface ISetExchangeParent {
  exchangeId: string | null;
  parentId: string;
}

/**
 * Sets the parent of a exchange
 *
 * @param {string} exchangeId - uuid of the exchange
 * @param {string} parentId - uuid of new parent or null
 */
export const setExchangeParent = ({ exchangeId, parentId }: ISetExchangeParent) => {
  return Brm.exchangeApi.setExchangeParent(exchangeId, { body: parentId });
};

interface IUseSetExchangeParent {
  options?: MutationOption<typeof setExchangeParent>;
}

/**
 * Custom hook to change the parent of an existing exchange
 *
 * @param {object} options - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetExchangeParent = ({ options }: IUseSetExchangeParent = {}) => {
  return ReactQuery.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(KeyFactory.exchangeKeys.all);
      queryClient.invalidateQueries(VariantKeyFactory.variantsKeys.all);
    },
    ...options,
    mutationFn: setExchangeParent,
  });
};
